import { configureStore } from '@reduxjs/toolkit';
import appReducer from './states/AppSlice';
import busyReducer from './states/BusySlice';
import categoryReducer from './states/CategorySlice';
import dialogReducer from './states/DialogSlice';
import errorReducer from './states/ErrorSlice';
import multiNumericReducer from './states/FeatureSlice';
import pdmReducer from './states/PdmSlice';
import propertyHistoryReducer from './states/PropertyHistorySlice';
import procosReducer from './states/procos';
import userReducer from './states/UserSlice';

export const AppStore = configureStore({
  reducer: {
    busy: busyReducer,
    error: errorReducer,
    app: appReducer,
    dialog: dialogReducer,
    procos: procosReducer,
    pdm: pdmReducer,
    category: categoryReducer,
    user: userReducer,
    multiNumeric: multiNumericReducer,
    propertyHistory: propertyHistoryReducer,
  },
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware({
      serializableCheck: false,
    });
  },
});

export type AppDispatch = typeof AppStore.dispatch;
export type AppState = ReturnType<typeof AppStore.getState>;
